import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NewTask from "../../Popups/NewTask";
import KendoClientDetailTasks from "./KendoClientDetailTask";
import { setTicketCustomerId } from "../../../store/reducers/TicketTaskFilter";

const ClientTask = (props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const dispatch = useDispatch();
  const [popupTask, setPopupTask] = useState(false);
  const [TaskInfo, setTaskInfo] = useState({
    status: "I",
    clientId: props.clientId,
    reRender: false,
  });
  const StatusTasks = [
    {
      label: "InProcess",
      value: "I",
    },
    {
      label: "Completed",
      value: "C",
    },
  ];

  const HandleSetTask = (childData) => {
    if (childData === true) {
      dispatch(setTicketCustomerId(sharedData.currentClientId));
      setPopupTask(false);
      setTaskInfo((prevData) => ({
        ...prevData,
        reRender: !TaskInfo.reRender,
      }));
    } else {
      setPopupTask(childData);
    }
  };

  const TriggerTask = () => {
    setPopupTask(true);
  };

  const AlterStatus = (e) => {
    setTaskInfo((prevData) => ({
      ...prevData,
      status: e.target.value,
    }));
  };

  return (
    <>
      {popupTask === true && <NewTask parentCallback={HandleSetTask} />}
      <div className="tab-pane inprocess" id="clientTask">
        <div role="tabpanel" className="tab-pane active" id="clientTask">
          <div className="table-panel task-table m-t-15">
            <div className="row table-panel-header">
              <div className="col-md-12 col-sm-12">
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <h6>Task Status</h6>
                  </div>
                  <div className="col-md-6 col-sm-6 flex-center-end">
                    <div className="col-md-3 col-sm-3">
                      <div className="border-none field-container m-0 min-h-0">
                        <select
                          className="field-input mt-0"
                          name="note"
                          value={TaskInfo.status}
                          onChange={(e) => AlterStatus(e)}
                        >
                          {StatusTasks.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 flex-center-end">
                      <div className="popuop_open">
                        <span
                          className="popuop_button popupBtn"
                          role="button"
                          onClick={() => TriggerTask(true)}
                        >
                          Add
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-panel-body" id="gridWidth">
              <KendoClientDetailTasks data={TaskInfo} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientTask;
